var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusIcon = function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    d: "M21.487 12.038a107 107 0 0 0-6.512-.424c-.716-.022-1.418-.002-2.14-.03.006-.476.027-.95-.002-1.418.012-3.132-.126-5.973-.254-7.249a.29.29 0 0 0-.298-.298.3.3 0 0 0-.298.298c.037 1.169-.138 3.656-.242 6.469l-.075 2.16c-.787.021-1.531.056-2.268.084-2.714.118-5.045.278-6.497.341a.3.3 0 0 0-.212.51.3.3 0 0 0 .212.085c1.616.044 4.365.118 7.433.156.433.007.893 0 1.333.001l-.007 1.027c-.032 2.984.02 5.768.07 7.235a.342.342 0 0 0 .681 0c.056-1.36.216-3.79.327-6.482l.07-1.786 2.005-.048c2.317-.019 4.627-.06 6.653.028a.345.345 0 1 0 .05-.688z",
    clipRule: "evenodd"
  })));
};
export default SvgPlusIcon;